@if (
  inspectionReportGroupsDataQueryLoadingState$ | async;
  as inspectionReportGroupsDataQueryLoadingState
) {
  @if (checkQueryParamValidity()) {
    @if (
      inspectionReportGroupsDataQueryLoadingState.reportState.data &&
      inspectionReportGroupsDataQueryLoadingState.inspectionGroupsState.data
    ) {
      <div class="report">
        <app-report-info-v2
          [data]="reportInfoData()"
          [spanPropertiesArray]="spanPropertiesArray()"
        />
        <app-report-comment />
        <app-report-groups-v2 />
      </div>
    }

    @if (showImagePreview$ | async) {
      <app-image-preview-v2
        [images]="(imagePreviewAttachments$ | async) ?? []"
        [isLoading$]="isLoadingImagePreview$"
        (closeModal)="closeImagePreview()"
        (downloadFiles)="downloadImages($event)"
        (uploadFiles)="uploadImage($event)"
        (deleteFile)="deleteImage($event)"
      />
    }
  } @else {
    <div class="center">
      <app-error-information
        [iconName]="'smileySad'"
        [iconColor]="'caution'"
        [errorString]="'reportInput.errorReport' | translate"
      />
    </div>
  }

  <app-feedback-alert />
}
